//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { InvoiceEmailType } from './Enums';

export class InvoiceEmailInputItem extends ItemBase {
    InvoiceID: string | null = null;
    AttemptAutoPay: boolean = false;
    SendAsSchool: boolean = false;
    BCCTeacher: boolean = false;
    RecipientParentIDs: string[] = [];
    UseTemplateSubjectAndMessageBody: boolean = false;
    Subject: string | null = null;
    MessageBody: string | null = null;
    EmailType: InvoiceEmailType = InvoiceEmailType.Invoice;

    constructor(initializer?: Partial<InvoiceEmailInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "InvoiceEmailInputItem";
}
